export default __webpack_public_path__ + "static/media/currency-usd.02676c4a.svg";